import { IonCol, IonGrid, IonRow, IonSkeletonText } from '@ionic/react'
import React from 'react'
import './residence-card-skeleton-grid.scss'
import { IResidenceCardSkeletonGridProps } from './residence-card-skeleton-grid-props.interface'

const ResidenceCardSkeletonGrid: React.FC<IResidenceCardSkeletonGridProps> = ({ count }) => {
  const elements = []

  for (let i = 0; i < count; i++) {
    elements.push(
      <IonCol size="12" size-md="6" sizeLg="3" className="residence-grid-col" key={i}>
        <div className="edisu-residence-card-skeleton edisu-residence-card">
          <div className="residence-card-header">
            <IonSkeletonText className="thumb-container" animated={true}></IonSkeletonText>
          </div>

          <div className="residence-card-content">
            <IonSkeletonText className="edisu-residence-address" animated={true} />
            <IonSkeletonText className="edisu-residence-name" animated={true} />

            <IonSkeletonText className="rating" />
          </div>
        </div>
      </IonCol>,
    )
  }

  return (
    <IonGrid className="edisu-residences-skeleton-grid edisu-residences-grid">
      <IonRow>{elements}</IonRow>
    </IonGrid>
  )
}

export default ResidenceCardSkeletonGrid
